module.exports = __webpack_public_path__ + "img/30.bd822b64.png";